import { Redirect, Route } from "react-router-dom";
import MainLayout from "layouts/MainLayout/index";
import { useOidc } from "@iso/helpers/oidc";

function PrivateRoute({ component, ...rest }) {
   const { isAuthenticated } = useOidc();

   return (
      <Route
         {...rest}
         render={() =>
            isAuthenticated ? (
               <MainLayout>{component}</MainLayout>
            ) : (
               <Redirect
                  to={{
                     pathname: "/",
                  }}
               />
            )
         }
      />
   );
}

export default PrivateRoute;
